module.exports = __webpack_public_path__ + "static/media/Janies_mill_FINAL-desktop.d17a47f9.jpg";